module.exports = __webpack_public_path__ + "img/react.c3fbd71b.svg";